import type { OrderDetailsDocuments } from '#api-bridge/types/orderDetailsDocuments.ts';
import type { Documents } from '#domain/Document.ts';

export const toOrderDetailsDocuments = (
    documents: Documents,
    loadingStopId?: string,
    unloadingStopId?: string,
    executionStopId?: string
): OrderDetailsDocuments => {
    const result = Object.groupBy(documents, doc => {
        for (const association of doc.associations ?? []) {
            if (executionStopId && association.type === 'tour-stop' && association.id === executionStopId) {
                return 'executionDocuments';
            }
            if (association.type === 'tour-stop' && association.id === loadingStopId) {
                return 'loadingDocuments';
            }
            if (association.type === 'tour-stop' && association.id === unloadingStopId) {
                return 'unloadingDocuments';
            }
        }

        return 'other';
    });

    return {
        loadingDocuments: result.loadingDocuments ?? [],
        unloadingDocuments: result.unloadingDocuments ?? [],
        executionDocuments: result.executionDocuments ?? [],
        other: result.other ?? [],
        length: documents.length,
    };
};
